import axios from "axios";

/**
 * Cliente de login / renovação de token.
 *
 * O Basic que autentica a aplicação saiu daqui: ele estava em texto puro no
 * bundle. Quem o injeta agora é o nginx, no caminho `/proxy/auth` (ver
 * `app/nginx.conf.template`). O Bearer devolvido pelo login continua vindo
 * para o navegador — é credencial do usuário, não da aplicação.
 */
const SetupAuth = axios.create({
  baseURL: "/proxy/auth",
});

export default SetupAuth;
